import script from "./DemographicsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DemographicsCard.vue?vue&type=script&setup=true&lang=js"

import "./DemographicsCard.vue?vue&type=style&index=0&id=69d76e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d76e38"]])

export default __exports__